const PaymentFailed = () => {
  return (
    <>
      <section className="about-hero d-flex align-items-center">
        <div className="about-hero-overlay"></div>
        <div className="container-fluid container-xl px-4 px-md-3">
          <h1 className="display-5 fw-bold text-white mb-1">❌ Payment Failed</h1>
          <p className="text-light mb-0">
            Your payment could not be completed.
          </p>
        </div>
      </section>
      <section id="our-story" className="py-5">
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <h1 className="display-5 fw-bold mb-1">❌ Payment Failed</h1>
          <p className="text-light mb-0">Your payment could not be completed.</p>
          <a href="/wallet">Try Again</a>
        </div>
      </section>
    </>
  );
};

export default PaymentFailed;
